import { meetingId } from '@/api';

export const getLocalPassword = (meetingId: string) => {
  const data = localStorage.getItem('meetingStore');
  const meetingStore = data ? JSON.parse(data) : {};
  return meetingStore[meetingId]?.password;
};
export const setLocalPassword = (meetingId: string, password: string) => {
  const data = localStorage.getItem('meetingStore');
  const meetingStore = data ? JSON.parse(data) : {};
  meetingStore[meetingId] = {
    password,
  };
  localStorage.setItem('meetingStore', JSON.stringify(meetingStore));
};

export const clearLocalPassword = (meetingId: string) => {
  const data = localStorage.getItem('meetingStore');
  const meetingStore = data ? JSON.parse(data) : {};
  delete meetingStore[meetingId];
  localStorage.setItem('meetingStore', JSON.stringify(meetingStore));
};
